<template>
  <div class="gm-admin-modal__responses">
    <div
      class="gm-admin-modal__qa"
      v-for="(importEle, index) in importResponsesData.questions"
      :key="index"
    >
      <p>Q{{ index + 1 }}. {{ importEle.questionLabel }}</p>
      <p>
        <span>{{ $t('frontend_groovemail_admin_import_user_approval_csv_response') }}:</span>
        {{ importEle.response }}
      </p>
    </div>

    <p class="gm-admin-modal__section-title gm-admin-modal__section-title--spaced">
      {{ this.$t('frontend_builder_websites') }}
    </p>
    <div class="gm-admin-kv">
      <div class="gm-admin-kv__head">
        <p class="w-1/2">
          {{ this.$t('frontend_groovemail_leads_import_multiple_leads_website_url_key') }}
        </p>
        <p class="w-1/2">{{ this.$t('frontend_email') }}</p>
      </div>
      <div
        class="gm-admin-kv__row"
        v-for="(webUrlData, index) in importResponsesData.website_urls"
        :key="index"
      >
        <p class="w-1/2">
          {{
            webUrlData.urlLink
              ? webUrlData.urlLink
              : $t('frontend_groovemail_not_available')
          }}
        </p>
        <p class="w-1/2">
          {{
            webUrlData.email
              ? webUrlData.email
              : $t('frontend_groovemail_not_available')
          }}<span
            v-if="webUrlData.verified"
            :title="$t('frontend_groovemail_admin_user_sender_verified')"
            class="ml-2"
            ><i class="fa fa-check" aria-hidden="true"></i
          ></span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'import-responses',
  props: {
    importResponsesData: {
      required: true,
    },
  },
};
</script>
